// Registry of all lesson presentations available in the Audio Studio.
// To add a new lesson later: import its lessonData module here and append
// a new entry with a unique id (used for the localStorage key).

import { photosynthesisLesson } from "./lessonData";
import { quadraticLesson } from "./quadraticLessonData";
import { soundWavesLesson, soundWavesStoryboard } from "./soundWavesLessonData";
import { gaseousLesson, gaseousStoryboard } from "./gaseousLesson";
import { angleLesson } from "./angleLessonData";

export const presentations = [
    {
        id: "angle-types-and-basics",
        title: angleLesson.title,
        subtitle: angleLesson.subtitle,
        grade: angleLesson.grade,
        chapter: angleLesson.chapter,
        lesson: angleLesson,
    },
    {
        id: "photosynthesis",
        title: photosynthesisLesson.title,
        subtitle: photosynthesisLesson.subtitle,
        grade: photosynthesisLesson.grade,
        chapter: photosynthesisLesson.chapter,
        lesson: photosynthesisLesson,
    },
    {
        id: "quadratic-equations",
        title: quadraticLesson.title,
        subtitle: quadraticLesson.subtitle,
        grade: quadraticLesson.grade,
        chapter: quadraticLesson.chapter,
        lesson: quadraticLesson,
    },
    {
        id: "characteristics-of-sound-waves",
        title: soundWavesLesson.title,
        subtitle: soundWavesLesson.subtitle,
        grade: soundWavesLesson.grade,
        chapter: soundWavesLesson.chapter,
        lesson: soundWavesLesson,
        defaultStoryboard: soundWavesStoryboard,
    },
    {
        id: "gaseous-state",
        title: gaseousLesson.title,
        subtitle: gaseousLesson.subtitle,
        grade: gaseousLesson.grade,
        chapter: gaseousLesson.chapter,
        lesson: gaseousLesson,
        // Pre-authored storyboard — Audio Studio uses this instead of the
        // synthesized buildStoryboard() output, since the deck content is
        // hand-curated and doesn't fit the photosynthesis fragment shape.
        defaultStoryboard: gaseousStoryboard,
        // External deck — student window opens this URL directly instead of
        // the React LessonStage.
        deckUrl: gaseousLesson.deckUrl,
    },
];

export const getPresentation = (id) =>
    presentations.find((p) => p.id === id) || presentations[0];

export const storyboardStorageKey = (presentationId) =>
    `sparkl-storyboard-${presentationId}-v1`;
